import React from 'react';
import moment from 'moment';
import styles from './PersonsTableLine.module.scss';
import sizes from '../persons-table-sizes.module.scss';
import { IconButton, AvatarImage, Tag } from 'components';
import { icons } from 'assets';
import { inject } from 'mobx-react';
import { ROUTING_STORE } from 'store';
import { getMainImageSrcForObj } from 'utilities';
import { WarningMessage } from 'components/common';
import { Props } from './types';


const PersonsTableLine = (props: Props) => {
  const {
    person,
    [ROUTING_STORE]: { push }
  } = props;

  return (
    <div
      className={styles.tableRow}
    >
      <div
        className={styles.nameContainer}
        onClick={() => push(`/persons/${person.id}`)}
      >
        <AvatarImage
          size={35}
          src={getMainImageSrcForObj(person)}
          alt={person.name}
        />
        <h4>{person.name}</h4>

        <WarningMessage
          object={person}
          objectType='person'
        />

      </div>

      <div style={{ width: sizes.dateAddedWidth }}>
        {moment(person.createdDate).format('HH:mm, DD.MM.YYYY')}
      </div>

      <div style={{ width: sizes.tagsWidth }}>
        {person.tags && person.tags.split(',').map((tag, index) =>
          <Tag key={index} tag={tag} />
        )}
      </div>

      <div className={styles.buttonsContainer}>
        <IconButton
          icon={icons.pen}
          className={styles.optionButton}
          onClick={() => push(`/persons/${person.id}`)}
        />
      </div>

    </div>
  );
};

export default inject(ROUTING_STORE)(PersonsTableLine);
